import { CorrectiveInvoice, Invoice } from 'pages/invoices/invoices.types';

export const isAllocationTabVisible = (
  invoice: Invoice | CorrectiveInvoice,
) => {
  if (invoice.invoiceClass.own || invoice.deleted) {
    return false;
  } else {
    return invoice.publicationDate;
  }
};
